import { fragments } from '@/gql'
import gql from 'graphql-tag'

export default gql`
  query  BestDownloadFilmFile ($id: ID!) {
    BestDownloadFilmFile: FilmMaster (id: $id) {
      id
      hostID
      hostURL
      hostType
      hostUserID
      filmID
      BestDownloadFilmFile {
        ...bestDownloadFilmFileDetail
        FilmFileArtifact {
          ...storageArtifactDetail
        }
      }
    }
  }
  ${fragments.filmFileDetail}
  ${fragments.filmFileDownloadDetail}
  ${fragments.filmFileArtifactDetail}
  ${fragments.bestDownloadFilmFileDetail}
`